export default "__VITE_ASSET__CZzuw9AG__"